module.exports = __webpack_public_path__ + "images/collections/business-class-feature-roadmap.cfed59ceb298324cf263.png";